import { useGetMeQuery } from '@pm/graphql';
import { useEffect, useRef } from 'react';
import { BackendEventMap } from './backend-event-types';
import { useTrackBackendEvent } from './use-track-backend-event';

export const useTrackBackendEventOnMount = <K extends keyof BackendEventMap>(
  eventName: K,
  properties?: BackendEventMap[K],
) => {
  const { data: meData, loading } = useGetMeQuery();
  const { trackBackendEvent } = useTrackBackendEvent({
    userId: meData?.me?.id,
  });
  const hasFired = useRef(false);

  useEffect(() => {
    if (hasFired.current || loading) return;
    trackBackendEvent(eventName, properties);
    hasFired.current = true;
    // properties intentionally omitted — inline objects would cause re-fires
    // eslint-disable-next-line react-x/exhaustive-deps -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
  }, [trackBackendEvent, eventName, loading]);
};
